export default "__VITE_ASSET__yX0moaRn__"